import React from 'react';
import uiConfig from '../../data/uiConfig';
import clsx from 'clsx';

interface SectionProps {
  children: React.ReactNode;
  className?: string;
  fullwidth?: boolean;
}

const Section: React.FC<SectionProps> = ({
  children,
  className = '',
  fullwidth = false
}) => {
  const maxWidth = uiConfig.section.maxWidth;

  return (
    <section
      className={clsx(
        fullwidth ? 'w-full' : `${maxWidth} px-4`,
        className)}
    >
      {children}
    </section>
  );
};

export default Section;